import type { RoiCode } from './roiCounterpart';
import codes from './mvisionRoiCodes.json';

const BY_NAME: Readonly<Record<string, RoiCode | undefined>> = codes;

// The anatomy code MVision assigns to one of its model structures, by that structure's name.
export function mvisionRoiCode(name: string): RoiCode | undefined {
    const code = BY_NAME[name.trim()];
    return code && { ...code };
}
